export default "__VITE_ASSET__5MxQnud2__"